import type { Ref } from 'react';
import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';

import type { SpaceProps } from '@/components/Box';
import type { TextProps } from '@/components/Text';
import { Text } from '@/components/Text';

import { switchScaleSettings } from './Typography.styles';

export type TypographyScales =
  | 'button'
  | 'p3'
  | 'p2'
  | 'p1'
  | 'p0'
  | 'h6Mobile'
  | 'h6'
  | 'h5Mobile'
  | 'h5'
  | 'h4Mobile'
  | 'h4'
  | 'h3Mobile'
  | 'h3'
  | 'h2'
  | 'h2Mobile'
  | 'h1'
  | 'h1Mobile';

export interface TypographyProps
  extends Omit<TextProps, 'fontSize' | 'lineHeight'>,
    SpaceProps,
    PropsWithChildren {
  scale?: TypographyScales;
}

export const Typography = forwardRef(
  (props: TypographyProps, ref: Ref<HTMLElement>) => {
    const { as, scale, ...rest } = props;

    return <Text ref={ref} as={as} {...switchScaleSettings(scale)} {...rest} />;
  },
);

Typography.defaultProps = {
  scale: 'p2',
  as: 'p',
};

Typography.displayName = 'Typography';
